import { useSearchParams } from 'react-router-dom';

import { TimelineActionsWrapper } from '../../components/chart-header/styles';
import TimeRangePicker from '../../components/time-range-picker/views-time-range-picker';
import { TimelineActions } from '../../components/timeline-actions/timeline-actions';
import { useLayoutContext } from '../../context/layout-context';
import { useViewContext } from '../../context/view-context';

import {
  Center,
  Container,
  Left,
  Right,
  TimeControls,
  TimeRange,
  ViewModeButton,
  ViewModes,
} from './styles';

import { Icon } from '@controlrooms/components/src/icon';
import { ICONS } from '@controlrooms/constants';
import { ViewType } from '@controlrooms/models';

export const ViewControls = () => {
  const { activeModes, setActiveModes, activeView } = useLayoutContext();
  const { viewId, setViewState } = useViewContext();

  const [, setSearchParams] = useSearchParams();

  const isMonitorMode = activeModes[activeView] === ViewType.MONITOR;
  const isAssessMode = activeModes[activeView] === ViewType.ANALYZE;
  const isInvestigateMode = activeModes[activeView] === ViewType.INVESTIGATE;

  const handleModeChange = (view: ViewType) => {
    setSearchParams('');
    setActiveModes((prev) => {
      return {
        ...prev,
        [activeView]: view,
      };
    });
    setViewState((prev) => ({
      ...prev,
      isDirty: true,
    }));
  };
  return (
    <Container>
      <Left>
        <ViewModes>
          <ViewModeButton
            selected={isMonitorMode}
            onClick={() => handleModeChange(ViewType.MONITOR)}
          >
            <Icon name={ICONS.Monitor} width="20" height="20" />
          </ViewModeButton>
          <ViewModeButton
            selected={isAssessMode}
            onClick={() => handleModeChange(ViewType.ANALYZE)}
          >
            <Icon name={ICONS.Assess} width="20" height="20" />
          </ViewModeButton>
          <ViewModeButton
            selected={isInvestigateMode}
            onClick={() => handleModeChange(ViewType.INVESTIGATE)}
          >
            <Icon name={ICONS.Investigate} width="20" height="20" />
          </ViewModeButton>
        </ViewModes>
      </Left>
      {/* <Center id={`view-chart-controls-${viewId}`}>
        <UtilityGroup>
          <UtilityButton>
            <Icon name={ICONS.Filter} width="14" height="14" /> Filters
            <DropdownIcon name="chevron" width="12" height="12" />
          </UtilityButton>
          <UtilityButton>
            <Icon name={ICONS.Group} width="16" height="16" /> Model
            <DropdownIcon name="chevron" width="12" height="12" />
          </UtilityButton>
          <UtilityButton>
            <Icon name={ICONS.Sort} width="16" height="16" /> System
            <DropdownIcon name="chevron" width="12" height="12" />
          </UtilityButton>
        </UtilityGroup>
        <ScaleGroup>
          <ScaleLabel>Scale</ScaleLabel>
          <IconicButton>
            <Icon name={ICONS.ScaleShrink} width="16" height="16" />
          </IconicButton>
          <IconicButton>
            <Icon name={ICONS.ScaleExpand} width="16" height="16" />
          </IconicButton>
          <ToggleGroup>
            <ToggleOption selected>fill</ToggleOption>
            <ToggleOption>Aligned</ToggleOption>
          </ToggleGroup>
        </ScaleGroup>
      </Center> */}
      <Right>
        <Center id={`view-chart-controls-${viewId}`}></Center>
        <TimeControls>
          {/* <TimeLabel>Time:</TimeLabel> */}
          <TimeRange>
            <TimeRangePicker />
          </TimeRange>
          <TimelineActionsWrapper>
            <TimelineActions />
          </TimelineActionsWrapper>
        </TimeControls>
      </Right>
    </Container>
  );
};

export default ViewControls;
